// TODO: Should really separate draggable stuff from item content - use composition

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ContentWarningIcon from './ContentWarningIcon'
import MarkdownLabel from '../mini/MarkdownLabel'

import { mapContentWarnings } from '../../utils/contentwarnings'
import { isNullOrEmpty } from '../../utils'
import { ResourceIncomplete } from '../../utils/resources'
import { getTruncatedString } from '../../utils/string'

export default class DraggableItem extends Component {
  constructor(props) {
    super(props)
    this.onEditClickBound = this.onEditClick.bind(this)
  }

  render() {
    const { item, commonProps } = this.props

    const displayAttr = (item, itemType) => {
      let retVal
      switch (itemType) {
        case 'note':
          retVal = item.attachment_name
          break
        case 'resource':
          retVal = getTruncatedString({
            val: item.name,
            len: 85
          })
          break
        case 'activity':
          retVal = item.name
          break
      }
      return retVal
    }

    return (
      <li className="draggable-item" id={`${commonProps.itemType}-${item.id}`}>
        <div className={`${commonProps.itemType}-wrapper`} data-id={item.id}>
          {this.props.dragHandle(
            <div className="dragdrop-wrapper">
              <div className="dragdrop">☰</div>
            </div>
          )}
          <div className="info-wrapper">
            <div
              className={`icon ${
                commonProps.itemType === 'resource'
                  ? item.resource_type
                  : item.file_type
              }`}
            />
            <div className="name">
              <div className="draggable-item-name-container">
                <div className="draggable-item-name">
                  {displayAttr(item, commonProps.itemType)}
                </div>
                {!commonProps.hideEdit && (
                  <div className="edit" onClick={this.onEditClickBound}></div>
                )}
              </div>
              {!commonProps.hideDelete && (
                <div className="trash" onClick={commonProps.deleteItem}></div>
              )}
            </div>
            {commonProps.itemType === 'resource' &&
              item.content_warnings &&
              Object.keys(item.content_warnings).length > 0 && (
                <div className="content-warnings-list">
                  {mapContentWarnings(item.content_warnings).map(cw => {
                    return (
                      <ContentWarningIcon
                        value={cw.value}
                        text={cw.text}
                        abbrev={cw.abbrev}
                        showTooltip
                      />
                    )
                  })}
                </div>
              )}
            {commonProps.hideDescription ||
            isNullOrEmpty(item.description) ? null : commonProps.itemType ===
              'resource' ? (
              <MarkdownLabel
                additionalCssClasses="resource description"
                value={item.description}
              />
            ) : (
              <div className="description">{item.description}</div>
            )}
            {commonProps.itemType === 'resource' &&
              item.isResourceIncomplete && <ResourceIncomplete />}
          </div>
        </div>
      </li>
    )
  }

  onEditClick() {
    const { item, commonProps } = this.props
    commonProps.handleEditClick(item)
  }
}

DraggableItem.propTypes = {
  item: PropTypes.object.isRequired,
  dragHandle: PropTypes.func.isRequired,
  commonProps: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/mini/DraggableItem.js